import { loaders } from 'entities';

import { ServicesSelect } from './ServicesSelect';
import { ServiceCount } from './ServiceCount';

import { StepComponentProps } from '../types';

export function Services({ state, dispatch }: StepComponentProps) {
  const { loading, data } = loaders.teams.allServices.use({
    defaultValue: [],
  });

  return (
    <>
      <ServicesSelect state={state} dispatch={dispatch} data={data} loading={loading} />

      {!!state.services.length && <ServiceCount state={state} dispatch={dispatch} data={data} />}
    </>
  );
}
